module.exports = __webpack_public_path__ + "assets/success-rosette.9158e381.svg";